// extracted by mini-css-extract-plugin
export default {"block":"key-info_block__89JaU","get":"key-info_get__kfnYi","post":"key-info_post__yKRFv","delete":"key-info_delete__wFzHZ","buttons":"key-info_buttons__WFZWL"};